module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a1q"
  }, [_c('PinchInQue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPinchIn),
      expression: "isShowPinchIn"
    }],
    attrs: {
      "pinchInText": _vm.pinchInText,
      "pathstep": _vm.pathstep,
      "pinchInShowVoice": _vm.showQestionVoice,
      "pinchInSound": _vm.pinchInSound
    },
    on: {
      "pinchOut": _vm.recievePinchOut,
      "pinchiInAudioPlay": _vm.audioPlay,
      "pinchInaudioPause": function($event) {
        return _vm.audioPause()
      }
    }
  }), _vm._v(" "), _c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-play"
  }, [_c('div', {
    staticClass: "eleAni flexcenter hide"
  }, [_vm._l((_vm.answersList), function(answer, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSelectAnswer),
        expression: "showSelectAnswer"
      }],
      key: index,
      staticClass: "item flexcenter hv",
      attrs: {
        "id": 'Answer' + index
      },
      on: {
        "touchstart": function($event) {
          return _vm.onTouchStart(_vm.answersTextList[index], answer.sounds[0])
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [(_vm.isEnvironmentPc()) ? _c('div', {
      staticClass: "input bg-white",
      class: _vm.getTextFontClassQue(_vm.answersTextList[index], _vm.productLanguage),
      on: {
        "click": function($event) {
          return _vm.clickAnswer(answer, index)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQestionText),
        expression: "showQestionText"
      }],
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.answersTextList[index]))
      }
    })]) : _c('div', {
      staticClass: "input bg-white",
      on: {
        "click": function($event) {
          return _vm.clickAnswer(answer, index)
        }
      }
    }, [_c('span', {
      style: ({
        visibility: _vm.showQestionText ? 'visible' : 'hidden'
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.answersTextList[index])
      }
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQestionText && _vm.showPinchInBtn),
        expression: "showQestionText && showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          return _vm.clickPinchIn(_vm.answersTextList[index], answer.sounds[0])
        }
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQestionVoice),
        expression: "showQestionVoice"
      }],
      staticClass: "icon-voice",
      on: {
        "click": function($event) {
          return _vm.audioPlay(answer.sounds[0])
        }
      }
    })])
  }), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()], 2)]), _vm._v(" "), _c('CommonAct', {
    attrs: {
      "pathstep": _vm.pathstep,
      "activeType": _vm.activeType,
      "actChoice": false,
      "horizontalRow": false,
      "scriptSystems": _vm.scriptSystems,
      "isShowTextsParent": _vm.isShowTextsParent,
      "isShowVoicesParent": _vm.isShowVoicesParent,
      "isActivesParent": _vm.isActivesParent,
      "isCorrectsParent": _vm.isCorrectsParent,
      "isInCorrectsParent": _vm.isInCorrectsParent,
      "needsSwiper": true,
      "changeActives": _vm.changeActives,
      "changeEndAct": _vm.changeEndAct,
      "changeIsCorrects": _vm.changeIsCorrects,
      "changeIsInCorrects": _vm.changeIsInCorrects,
      "changeIsShowTexts": _vm.changeIsShowTexts,
      "changeIsShowVoices": _vm.changeIsShowVoices
    },
    on: {
      "actPinchIn": _vm.recieveActPinchIn
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-230e9779", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-230e9779","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A1Q.vue
// module id = 855
// module chunks = 1